<template>
  <div class="page-wallet">
    <FrameHeader/>

    <div class="boxed py-5 mb-5" style="max-width: 1000px;">

      <h4 class="mb-4">
        {{lg('',{
          en: 'Activity',
          zh: '交易记录',
        })}}
      </h4>

      <!-- activity -->
      <div v-if="status_loading_history" class="tac t-gray p-5">
        Loading...
      </div>
      <BlockHistory v-if="!status_loading_history" :list_history="list_history" class=""/>

    </div>
  </div>
</template>

<script>
import bus from '@/bus.js'
import BlockHistory from '../wallet/blockHistory.vue'

export default {
  name: 'activity',
  components: {
    BlockHistory,
  },
  props: [],
  data() {
    return {

      account_wallet: this.$store.state.web3.account_wallet,

      // activity
      status_loading_history: false,
      list_history: [],

      // list_activity: [
      //   {
      //     id: '1',
      //     name: 'Receive',
      //   },
      //   {
      //     id: '2',
      //     name: 'Send',
      //   },
      //   {
      //     id: '3',
      //     name: 'Purchase',
      //   },
      //   {
      //     id: '4',
      //     name: 'sale',
      //   },
      // ],
    }
  },
  computed: {
    balance_total_on_usd(){
      let v = this

      let fn = v.$options.filters['tokenToUsd']

      let mark = 0

      v.$store.state.web3.account_wallet.forEach(function(item){
        let res = fn(item.num,item.id)
        if(typeof res === 'number'){
          mark += res
        }
      })

      return mark
    },
  },
  watch: {

  },
  methods: {

    async getHistory(){
      let v = this

      await v.uniGetCurrentBlockNum()

      if(v.list_history.length === 0){
        v.status_loading_history = true
      }

      let res = await v.api('list_site_history',{
        address: v.$store.state.web3.account,
      },{
        vue: v,
        key_data: 'list_history',
      })

      v.status_loading_history = false
    },
    
  },
  created() {
    this.getHistory()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .page-wallet{

    
    @media(min-width: 788px){
      .block-papa{
        display: flex;
        .block-user{
          width: 240px;
          height: 100%;
          position: sticky; top: 70px; z-index: 10;
        }
        .block-wallet{
          border-left: 1px solid $c_border;
          min-height: 80vh;
          flex: 1;
        }
      }
    }
  }
</style>